


























import { Component, Vue, Prop } from "vue-property-decorator";
import { IInvoice } from "@/models/invoices";

@Component({
  components: {
    "legacy-invoice-provider": () =>
      import(
        "@/components/app/global/legacyInvoices/legacyInvoiceProvider.vue"
      ),
    "legacy-invoice-details": () =>
      import("@/components/app/global/legacyInvoices/legacyInvoiceDetails.vue")
  }
})
export default class LegacyInvoiceModal extends Vue {
  // Props
  @Prop({ required: true })
  public invoiceId!: IInvoice["id"];

  // Life-cycle methods
  public beforeDestroy() {
    if (["adminClientLegacyInvoice"].includes(this.$route.name as string)) {
      const path = this.$route.fullPath.replace(this.invoiceId, "");
      this.$router.replace(path).catch(err => err);
    }
  }
}
